import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { AsociacionFirmaPlantillaComponent } from './asociacion-firma-plantilla.component';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [AsociacionFirmaPlantillaComponent],
  imports: [
    SharedModule,
    CommonModule,
  ],
  exports: [
    AsociacionFirmaPlantillaComponent // Exporta el componente para que otros módulos puedan usarlo
  ]
})
export class AsociacionFirmaPlantillaModule { }
